import { DemoDefinition } from "../DemoDefinition";
import { DemoRegistry } from "../DemoRegistry";
import { AutogenLayoutDemoDateTimeDialog } from "./autogen/AutogenLayoutDemoDateTimeDialog";

export class DemoDateTimeDialog extends AutogenLayoutDemoDateTimeDialog {
}
DemoRegistry.get().register(new DemoDefinition("dialogs/DemoDateTimeDialog", [ "Dialogs", "Date/Time Pickers" ]));
